var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path2, _rect11, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondFloor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361 531",
    width: 361,
    height: 531,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 357,
    height: 527,
    fill: "#ffffff",
    stroke: "#000",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "f2k",
    x: 2,
    y: 2,
    width: 202,
    height: 148,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "f2l",
    x: 204,
    y: 2,
    width: 155,
    height: 148,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f2h",
    d: "M102 150 H359 V234 H201 V529 H155 V234 H102 Z",
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "f2s",
    x: 2,
    y: 329,
    width: 153,
    height: 91,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "f2b1",
    x: 201,
    y: 334,
    width: 158,
    height: 99,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "f2b2",
    x: 2,
    y: 420,
    width: 153,
    height: 109,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "f2b3",
    x: 2,
    y: 234,
    width: 153,
    height: 95,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "f2w1",
    x: 296,
    y: 433,
    width: 63,
    height: 96,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "f2w2",
    x: 201,
    y: 433,
    width: 95,
    height: 96,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "f2w3",
    x: 2,
    y: 190,
    width: 100,
    height: 44,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "f2w4",
    x: 299,
    y: 234,
    width: 60,
    height: 55,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "f2aux1",
    x: 2,
    y: 150,
    width: 73,
    height: 40,
    fill: "#eeeeee",
    stroke: "#000",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "f2s",
    d: "M201 234 H299 V289 H359 V334 H201 Z",
    fill: "#eeeeee",
    stroke: "#000",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "f2p",
    x: 75,
    y: 150,
    width: 27,
    height: 40,
    fill: "#eeeeee",
    stroke: "#000",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 70,
    y: 76
  }, "Kitchen")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 230,
    y: 76
  }, "Living Room")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "label small",
    x: 40,
    y: 215
  }, "W3")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 200,
    y: 195
  }, "Hall")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 285
  }, "Bedroom 4")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 375
  }, "Storage")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 475
  }, "Bedroom 2")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 240,
    y: 384
  }, "Bedroom 1")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "label small",
    x: 320,
    y: 270,
    transform: "rotate(-90 329 262)"
  }, "W4")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 315,
    y: 485
  }, "W 1")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 235,
    y: 485
  }, "W 2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondFloor);
export default __webpack_public_path__ + "static/media/second_floor.2d516b90dc05ad8990d1aa00f882f5ae.svg";
export { ForwardRef as ReactComponent };